import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "gender"
})
export class GenderPipe implements PipeTransform {
    transform(val: string) {
        switch (val) {
            case "M":
                return "Male";
            case "F":
                return "Female";
            case "O":
                return "Other";
            case "A":
                return "Ambiguous";
            default:
                return "N/A";
        }
    }
}